import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from '@grupa-pracuj/react-tabs';
import PropTypes from 'prop-types';

import {
  LAST_SEEN, SAVED, APPLIED, setTab
} from 'src/redux/actions/tabs';
import {
  getAppliedOffers,
  getLastSeenOffers,
  getSavedOffers
} from 'src/redux/actions/offers';
import styles from 'src/containers/OfferTabsContainer.scss';


class OfferTabsContainer extends PureComponent {
  displayLastSeen = () => {
    const { dispatch } = this.props;

    dispatch(setTab({ activeTab: LAST_SEEN }));
    dispatch(getLastSeenOffers());
  };

  displayAppliedOffers = () => {
    const { dispatch } = this.props;

    dispatch(setTab({ activeTab: APPLIED }));
    dispatch(getAppliedOffers());
  };

  displaySavedOffers = () => {
    const { dispatch } = this.props;

    dispatch(setTab({ activeTab: SAVED }));
    dispatch(getSavedOffers());
  };

  render() {
    const { displayLastSeen, displayAppliedOffers, displaySavedOffers } = this;
    const { tab } = this.props;

    const lastSeenTabText = 'Ostatnio oglądane';
    const saveTabText = 'Zapisane';
    const appliedTabText = 'Wysłane aplikacje';

    return (
      <Tabs
        customClasses={ {
          customClass: styles['tabs-container'],
          customWrapper: styles['tabs-wrapper'],
          customUnderline: styles['tabs-underline'],
          customBorder: styles['tabs-border']
        } }
        customTabClasses={ {
          customClass: styles.tab,
          customActiveClass: styles['tab--active']
        } }
        initialActiveTab={ tab }
      >
        <Tab id={ LAST_SEEN } onClick={ displayLastSeen }>
          {lastSeenTabText}
        </Tab>
        <Tab id={ SAVED } onClick={ displaySavedOffers }>
          {saveTabText}
        </Tab>
        <Tab id={ APPLIED } onClick={ displayAppliedOffers }>
          {appliedTabText}
        </Tab>
      </Tabs>
    );
  }
}

OfferTabsContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tab: PropTypes.string.isRequired
};

const mapStateToProperties = state => ({
  tab: state.tabsReducer.activeTab
});

export default connect(mapStateToProperties)(OfferTabsContainer);
